import BaseListStyle from "../../styles/BaseListStyle";

const AircraftStyles = (theme) => {
  const baseListStyle = BaseListStyle(theme);
  return {
    ...baseListStyle,
    /* Add custom styles here */
    rooted: {
      display: "flex",
    },
    DefectsEditor: {
      "& .MuiTableHead-root": {
        backgroundColor: theme.palette.childTableHeader.backgroundColor,
        display: "block",
        tableLayout: "fixed",
        paddingRight: 20,
      },
      "& .MuiTableSortLabel-root": {
        color: theme.palette.secondary.main,
      }
    },
    tableStyle: {
      color: "black",
      fontSize: "14pt",
      fontFamily: "sans-serif",
      textAlign: "center",
      verticalAlign: "middle",
      borderCollapse: "collapse",
      margin: "10px 0",
      // boxShadow: "0 0 20px rgba(0, 0, 0, 0.15)",
    },
    headersMain: {
      fontSize:"12.0pt",
      fontWeight:700,
      fontFamily: "Arial, cursive",
      textAlign: "center",
      verticalAlign: "middle",
      whiteSpace: "normal",
    },
    headersSub: {
      fontSize:"9.0pt",
      fontWeight:700,
      fontFamily: "Arial, cursive",
      textAlign: "center",
      verticalAlign: "middle",
      whiteSpace: "normal",
    },
    rowStyle: {
      borderBottom: "1px solid #e8e8e8"
    },
    thinBorder: {
      borderTop: "0.5pt solid #000000",
      borderRight: "0.5pt solid #000000",
      borderBottom: "0.5pt solid #000000",
      borderLeft: "0.5pt solid #000000",
    },
    thinLeftTopBorder: {
      borderTop: "0.5pt solid #000000",
      borderLeft: "0.5pt solid #000000",
    },
    thinLeftBottomBorder: {
      borderLeft: "0.5pt solid #000000",
      borderBottom: "0.5pt solid #000000",
    },
    thinNoBottomBorder: {
      borderTop: "0.5pt solid #000000",
      borderRight: "0.5pt solid #000000",
      borderLeft: "0.5pt solid #000000",
    },
    thinNoTopBorder: {
      borderRight: "0.5pt solid #000000",
      borderLeft: "0.5pt solid #000000",
      borderBottom: "0.5pt solid #000000",
    },
    thinLeftBorder: {
      borderLeft: "0.5pt solid #000000",
    },
    thinRightBorder: {
      borderRight: "0.5pt solid #000000",
    },
    topLeftBorder: {
      borderTop: "1.0pt solid #000000",
      borderLeft: "1.0pt solid #000000",
    },
    topBorder: {
      borderTop: "1.0pt solid #000000",
    },
    topRightBorder: {
      borderTop: "1.0pt solid #000000",
      borderRight: "1.0pt solid #000000",
    },
    leftBorder: {
      borderLeft: "1.0pt solid #000000",
    },
    rightBorder: {
      borderRight: "1.0pt solid #000000",
    },
    bottomLeftBorder: {
      borderBottom: "1.0pt solid #000000",
      borderLeft: "1.0pt solid #000000",
    },
    bottomBorder: {
      borderBottom: "1.0pt solid #000000",
    },
    bottomRightBorder: {
      borderRight: "1.0pt solid #000000",
      borderBottom: "1.0pt solid #000000",
    },
    noTopBorder: {
      borderTop: "none",
    },
    noLeftBorder: {
      borderLeft: "none",
    },
    noRightBorder: {
      borderRight: "none",
    },
    noBottomBorder: {
      borderBottom: "none",
    },
  }
}

export default AircraftStyles;
